import { useEffect, useState } from 'react';
import api, { authAPI } from './api';

const KEY = 'referralCode';

// Rewarded sharing: the logged-in customer's referral code is cached locally so every shared link can carry ?ref=<code> synchronously
export const getReferralCode = () => {
  try { return authAPI.isAuthenticated() ? (localStorage.getItem(KEY) || '') : ''; } catch { return ''; }
};

export const clearReferralCode = () => { try { localStorage.removeItem(KEY); } catch { /* ignore */ } };

export const referralAPI = {
  mine: async () => (await api.get('/account/referral')).data,
};

let pending = null;
export const ensureReferralCode = async () => {
  if (!authAPI.isAuthenticated()) return '';
  const cached = getReferralCode();
  if (cached) return cached;
  if (!pending) {
    pending = referralAPI.mine().then((d) => { if (d?.code) localStorage.setItem(KEY, d.code); return d; }).catch(() => null).finally(() => { pending = null; });
  }
  const d = await pending;
  return d?.code || '';
};

// Loads (once) the customer's referral programme info: {code, percent, enabled, rewards…}; null for guests
export const useReferral = () => {
  const [data, setData] = useState(null);
  const authed = authAPI.isAuthenticated();
  useEffect(() => {
    if (!authed) { setData(null); return; }
    let on = true;
    referralAPI.mine().then((d) => { if (!on) return; if (d?.code) localStorage.setItem(KEY, d.code); setData(d); }).catch(() => on && setData(null));
    return () => { on = false; };
  }, [authed]);
  return data;
};
